import React from "react";
import { useTranslation } from "react-i18next";

export default function Navigation()
{
    const { t, i18n } = useTranslation();
    function setLangEs(e) 
    {
        e.preventDefault();    
        i18n.changeLanguage("es");
    }
    function setLangEn(e) 
    {
        e.preventDefault();    
        i18n.changeLanguage("en");
    }
    return(
        <nav className="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
        <div className="container">
            <a className="navbar-brand" href="#page-top"><img src='assets/img/logo.png' alt='logo'/></a>
            <button className="navbar-toggler text-uppercase font-weight-bold bg-primary text-white rounded" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                Menu
                <i className="fas fa-bars"></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item mx-0 mx-lg-1"><a className="nav-link py-3 px-0 px-lg-3 rounded" href="#quienessomos">{t('nav_menu1')}</a></li>
                    <li className="nav-item mx-0 mx-lg-1"><a className="nav-link py-3 px-0 px-lg-3 rounded" href="#servicios">{t('nav_menu2')}</a></li>
                    <li className="nav-item mx-0 mx-lg-1"><a className="nav-link py-3 px-0 px-lg-3 rounded" href="#testimonios">{t('nav_menu3')}</a></li>
                    <li className="nav-item mx-0 mx-lg-1"><a className="nav-link py-3 px-0 px-lg-3 rounded" href="#nuestroequipo">{t('nav_menu4')}</a></li>
                    <li className="nav-item mx-0 mx-lg-1"><a className="nav-link py-3 px-0 px-lg-3 rounded" href="#contacto">{t('nav_menu5')}</a></li>
                </ul>
                <div className='languageSelector'>
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item mx-0 mx-lg-1"><a className="py-3 px-0 px-lg-3 rounded" href="#page-top" onClick={setLangEs}><img src="assets/img/spain.svg" className="flag" alt="es"/></a></li>
                    <li className="nav-item mx-0 mx-lg-1"><a className="py-3 px-0 px-lg-3 rounded" href="#page-top" onClick={setLangEn}><img src="assets/img/us.svg" className="flag" alt="us"/></a></li>
                </ul>
            </div>
            </div>
        </div>
        </nav>
    )
}